import { createSlice } from '@reduxjs/toolkit';

const reports = createSlice({
  name: 'reports',
  initialState: {
    snapshot: {},
    isLoading: false,
  },
  reducers: {
    snapshotRequest(state) {
      state.isLoading = true;
    },
    snapshotSuccess(state, { payload }) {
      return {
        snapshot: payload,
        isLoading: false,
      };
    },
    snapshotFailure(state) {
      state.isLoading = false;
    },
  },
});

const { actions, reducer } = reports;

export const { snapshotRequest, snapshotSuccess, snapshotFailure } = actions;

export default reducer;
